import { Form } from 'formik';
import { Box, styled } from '@material-ui/core';

import { SButton } from '@setvi/shared/components';
import { distances } from '@setvi/shared/styles';

export const Container = styled(Box)({
  margin: 'auto',
  flexDirection: 'column',
  border: `1px solid #AFBAC6`,
  borderRadius: 20,
  flex: 1,
  backgroundColor: '#fff',
  padding: distances.px.base,
  overflow: 'auto'
});

export const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(2, 0, 3, 0)
}));

export const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gridGap: 8
});

export const LabelContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gridGap: 8
});

export const ClearButton = styled(SButton)({
  textDecoration: 'underline',
  fontWeight: 'normal',
  visibility: ({ hide }: { hide: boolean }) => (hide ? 'hidden' : 'visible')
});

export const FormikContainer = styled(Box)({
  flex: 1,
  height: '100%'
});

export const InputContainer = styled(Form)({
  flex: 1,
  height: '100%',
  position: 'relative'
});

export const SubmitButton = styled(SButton)({
  background: 'linear-gradient(135deg,  #256EE4 5%, #003A6C 30%, #001222 90%)',
  position: 'absolute',
  fontWeight: 500,
  bottom: 15,
  right: 15,

  '&.Mui-disabled': {
    opacity: 0.6,
    color: 'white'
  }
});

export const RankingButton = styled(SButton)({
  position: 'absolute',
  fontWeight: 500,
  bottom: 15,
  left: 15,

  '&.Mui-disabled': {
    opacity: 0.6
  }
});

export const Placeholder = styled(Box)({
  top: 18,
  left: 15,
  fontSize: 16,
  fontWeight: 400,
  position: 'absolute',
  color: '#AFBAC6',
  height: '80%',
  overflow: 'auto',
  wordBreak: 'break-word',
  pointerEvents: 'none',
  zIndex: 2,
  paddingRight: 4,
  '& p': {
    wordBreak: 'break-word'
  }
});

export const inputStyle = {
  backgroundColor: '#fff',
  wordBreak: 'break-word',
  paddingBottom: 56,
  borderColo: 'red',
  borderRadius: 12,
  zIndex: 1
};
